import React from "react";
function BuyMeACoffeeButton() {
    return (
        <div style={{
            position: 'fixed', // The element is positioned relative to the viewport
            bottom: '60px', // 20 pixels from the bottom
            right: '20px', // 20 pixels from the right
            zIndex: 1000, // Ensure it stays on top of other content
        }}>
            <a href="https://www.buymeacoffee.com/axy.org">
                <img
                    style={{ height: "50px" }}
                    alt="Buy Me a Coffee Widget"
                    src="/images/orange-button.png"
                />
            </a>
        </div>
    );
}

export default BuyMeACoffeeButton;